module.exports = "<div class=\"radio\">\n  <label class=\"l-nav-main__filter-label\">\n    <input class='radio-btn' name=\"filterRadios\" type=\"radio\" value=\"{{ label }}\" (change)=\"onChange($event)\" [checked]=\"checked\">\n    <span>{{ label }}</span>\n  </label>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/components/nav/filter-item/nav-filter-item.html
// module id = ./src/app/main/components/nav/filter-item/nav-filter-item.html
// module chunks = main